// generateInvoicePDF.js
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generateInvoicePDF = async (invoiceData) => {
  const {
    patientId,
    clinicId,
    issuedDate,
    totalAmount,
    discountAmount,
    paidAmount,
    lineItems,
    doctorName,
    paymentMethod,
    paymentDetails,
    clinicDetails,
    patientDetails
  } = invoiceData;

  // Hardcoded details (replace with actual data later)

  const invoiceNumber = 'INV-001';
  const invoiceDate = issuedDate.toLocaleDateString();

  const lineItemsDiscount = lineItems.reduce((acc, item) => acc + (item.quantity * item.discount), 0);;

  const contentHTML = `
    <div id="pdf-content" style="font-size: 10px; font-family: Arial, sans-serif; width: 210mm; height: 297mm;">
    <div style="padding: 15mm; box-sizing: border-box; height: 100%;">
      <div style="display: flex; justify-content: space-between; margin-bottom: 5mm;">
        <div>
          <h1 style="font-size: 16px; font-weight: bold; margin: 0;">${clinicDetails.name}</h1>
          <h3 style="font-size: 10px; font-weight: bold; margin: 0;">Dr.${doctorName}</h3>


        </div>
          <div style="text-align: right;">
            <p style="margin: 0;"><strong>Invoice No:</strong> ${invoiceNumber}</p>
            <p style="margin: 0;"><strong>Invoice Date:</strong> ${invoiceDate}</p>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5mm;">
          <div>
            <p style="margin: 0;"><strong>Patient:</strong> ${patientDetails.name}</p>
            <p style="margin: 0;"><strong>UHID:</strong> ${patientDetails.uhid}</p>
            <p style="margin: 0;"><strong>Phone:</strong> ${patientDetails.phoneNumber}</p>
          </div>
          <div style="text-align: right;">
            <p style="margin: 0;"><strong>Payment Status:</strong> ${patientDetails.paymentStatus}</p>
          </div>
        </div>
        <hr style="border-top: 1px solid #000; margin-bottom: 5mm;">
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 5mm;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Service</th>
              <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Qty</th>
              <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Amount</th>
              <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Discount</th>
              <th style="border: 1px solid #000; padding: 2mm; background-color: #f2f2f2;">Total</th>
            </tr>
          </thead>
          <tbody>
            ${lineItems.map(item => `
              <tr>
                <td style="border: 1px solid #000; padding: 2mm;">${item.description}</td>
                <td style="border: 1px solid #000; padding: 2mm; text-align: center;">${item.quantity}</td>
                <td style="border: 1px solid #000; padding: 2mm; text-align: right;">Rs ${Number(item.unitPrice).toFixed(2)}</td>
                <td style="border: 1px solid #000; padding: 2mm; text-align: right;">Rs ${Number(item.discount).toFixed(2)}</td>
                <td style="border: 1px solid #000; padding: 2mm; text-align: right;">Rs ${(item.unitPrice * item.quantity - item.discount * item.quantity).toFixed(2)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <div style="display: flex; justify-content: flex-end; margin-bottom: 5mm;">
          <div style="text-align: right;">
            <p style="margin: 0; font-weight: 900;"><strong>Sub-Total:</strong> Rs ${Number(totalAmount).toFixed(2)}</p>
            <p style="margin: 0;"><strong>Line Items Total Discount:</strong> Rs ${Number(lineItemsDiscount).toFixed(2)}</p>
            <p style="margin: 0;"><strong>Additional Discount:</strong> Rs ${Number(discountAmount).toFixed(2)}</p>
            <p style="margin: 0; font-weight: 900;"><strong>Grand Total:</strong> Rs ${Number((totalAmount - lineItemsDiscount - discountAmount)).toFixed(2)}</p>
            <p style="margin: 0;"><strong>Paid Amount:</strong> Rs ${Number(paidAmount).toFixed(2)}</p>
            <p style="margin: 0; font-weight: 900;"><strong>Balance Amount:</strong> Rs ${Number((totalAmount - lineItemsDiscount - discountAmount - paidAmount)).toFixed(2)}</p>
          </div>
        </div>
      </div>
    </div>
  `;

  // Create a hidden div element and append the HTML content
  const pdfContainer = document.createElement('div');
  pdfContainer.style.position = 'absolute';
  pdfContainer.style.left = '-9999px';
  pdfContainer.style.top = '0px';
  pdfContainer.innerHTML = contentHTML;
  document.body.appendChild(pdfContainer);
  
  // Use html2canvas to take a snapshot of the div and turn it into a canvas
  const canvas = await html2canvas(pdfContainer, {
    scale: 2.5, // Increase the scale for better resolution
    useCORS: true // Use CORS to handle external image security
  });

  // Calculate the dimensions of the PDF
  const pdfWidth = 210;
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  // Initialize jsPDF
  const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight]);

  // Add the canvas as an image to the PDF
  const imgData = canvas.toDataURL('image/jpeg', 1.0);
  pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

  // Clean up: Remove the hidden div
  document.body.removeChild(pdfContainer);

  // Output the PDF as a blob
  const pdfBlob = pdf.output('blob');

  return pdfBlob;
};